module.exports = __webpack_public_path__ + "static/media/avatar_verify_default.5fc90e0f.svg";